// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"2a2327bb","88":"dfd01cf1","89":"947c6e8b","453":"d8e0219e","463":"4701bf66","470":"27adfd1a","487":"1fc4c1f2","562":"eb0afec0","832":"2f326c3b","834":"29e5aa68"}[chunkId] + ".chunk.js";
};